import { DocumentNode, gql } from '@apollo/client'

export const SWITCH_DAYCARE_NEWS_ACCESS: DocumentNode = gql`
    mutation SwitchDaycareNewsAccess($daycareId: Int!) {
        switchDaycareNewsAccess(daycare_id: $daycareId)
    }
`

export const SWITCH_DAYCARE_SUGGEST_ACCESS: DocumentNode = gql`
    mutation SwitchDaycareSuggestAccess($daycareId: Int!) {
        switchDaycareSuggestAccess(daycare_id: $daycareId)
    }
`

export const SWITCH_DAYCARE_STAFF_ACCESS: DocumentNode = gql`
    mutation SwitchDaycareStaffAccess($daycareId: Int!) {
        switchDaycareStaffAccess(daycare_id: $daycareId)
    }
`

export const SWITCH_DAYCARE_TASK_NOTE_ACCESS: DocumentNode = gql`
    mutation SwitchDaycareTaskNoteAccess($daycareId: Int!) {
        switchDaycareTaskNoteAccess(daycare_id: $daycareId)
    }
`

export const SWITCH_DAYCARE_MEAL_ACCESS: DocumentNode = gql`
    mutation SwitchDaycareMealAccess($daycareId: Int!) {
        switchDaycareMealAccess(daycare_id: $daycareId)
    }
`

export const SET_NEW_DAYCARE_ANNUAIRE_ID: DocumentNode = gql`
    mutation SetNewDaycareAnnuaireId($daycareId: Int!, $annuaireId: Int!) {
        setNewDaycareAnnuaireId(daycareId: $daycareId, annuaireId: $annuaireId)
    }
`
